document.addEventListener('DOMContentLoaded', function() {
  var carousels = document.querySelectorAll('.simple-carousel .swiper-container');
  carousels.forEach(function(container) {
    // Check if this is a card style carousel
    var isCardStyle = container.closest('.simple-carousel-wrapper').classList.contains('card-style');
    
    var swiperConfig = {
      slidesPerView: 'auto',
      spaceBetween: isCardStyle ? 16 : 8,
      navigation: {
        nextEl: container.querySelector('.swiper-button-next'),
        prevEl: container.querySelector('.swiper-button-prev'),
      },
      loop: true,
      centeredSlides: false,
    };
    
    // Add responsive breakpoints for card style
    if (isCardStyle) {
      swiperConfig.breakpoints = {
        480: {
          spaceBetween: 16,
        },
        768: {
          spaceBetween: 20,
        },
        1024: {
          spaceBetween: 24,
        }
      };
    }
    
    new Swiper(container, swiperConfig);
  });
}); 